import { useCreateCompanyDocumentConfirmation } from "./model/use-create-company-document-confirmation";
import { CompanyDocumentConfirmationForm } from "./ui/company-document-confirmation-form";

export function CreateCompanyDocumentConfirmation({
  documentId,
  afterSubmit,
}: {
  documentId: string;
  afterSubmit?: () => void;
}) {
  const { create, loading } = useCreateCompanyDocumentConfirmation({
    afterSubmit,
  });

  return (
    <CompanyDocumentConfirmationForm
      layout="vertical"
      onFinish={create}
      disabled={loading}
      initialValues={{
        documentId,
      }}
    />
  );
}
